import { ImageRepository } from '../../domain/repositories/image.repository';
import { ImageEntity } from '../../domain/entities/image.entity';

export class GetImagesUseCase {
  constructor(private readonly imageRepository: ImageRepository) {}

  public async execute(search?: string): Promise<ImageEntity[]> {
    return this.imageRepository.getImages(search);
  }
}
